<div class="w-100" fxLayout="column" fxLayoutAlign="star start">
    <div class="common-info-container">
        @for (field of fields; track field) {
            <div class="t2 c-primary-gray-600">{{ field.label | translate }}</div>
            <div class="t2 c-primary-gray-900">{{ field.value }}</div>
        }
    </div>
</div>
